import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

/*
  Generated class for the TabUpdateProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TabUpdateProvider {

  moduleUpdates = new ReplaySubject(1);
  tabUpdates: Subject<number> = new Subject();

  constructor() {
  }

}




// WEBPACK FOOTER //
// ./src/providers/tab-update/tab-update.service.ts